import React from "react"
import PropTypes from "prop-types"

import "./button.css"

const Button = ({
  action,
  clicked,
  Logo = null,
  logoFillStyle = false,
  text = "",
  switchMode = false,
  reset,
  resetCallback,
}) => {
  const clickedClass = "clicked"
  const animationDuration = 0.6

  const [internalClicked, setInternalClicked] = React.useState(false)
  const animation_timeout = React.useRef(null)

  React.useEffect(() => {
    if (reset && switchMode) {
      resetCallback()
      setInternalClicked(false)
      animation_timeout.current = setTimeout(() => {
        animation_timeout.current = null
      }, animationDuration * 1000)
    }
  })

  const handleClick = event => {
    if (!switchMode) {
      if (!animation_timeout.current) {
        setInternalClicked(true)
        animation_timeout.current = setTimeout(() => {
          setInternalClicked(false)
          animation_timeout.current = setTimeout(() => {
            if (action) {
              action()
            }
            animation_timeout.current = null
          }, animationDuration * 1000)
        }, animationDuration * 1000)
      }
    } else {
      if (!animation_timeout.current) {
        if (internalClicked) {
          setInternalClicked(false)
        } else {
          setInternalClicked(true)
        }
        action()
        animation_timeout.current = setTimeout(() => {
          animation_timeout.current = null
        }, animationDuration * 1000)
      }
    }
  }

  return (
    <button
      className={`raphael-button${
        clicked ?? internalClicked ? " " + clickedClass : ""
      }`}
      onClick={handleClick}
      style={{
        transition: `box-shadow ${animationDuration}s cubic-bezier(.79,.21,.06,.81)`,
      }}
    >
      {Logo ? (
        <Logo className={`logo${logoFillStyle ? " fill-style" : ""}`} />
      ) : null}
      {text !== "" ? <span className="text">{text}</span> : null}
    </button>
  )
}

Button.propTypes = {
  clicked: PropTypes.bool,
  logoFillStyle: PropTypes.bool,
  Logo: PropTypes.func,
  text: PropTypes.string,
  action: PropTypes.func,
  reset: PropTypes.bool,
  resetCallback: PropTypes.func,
}

export default Button
